
import {
  SET_DATA_END_ORDER,
  SET_ITENS,
  SET_ADRESS_TO_DELIVERY
} from "../actions/actions"

export default function (state = { itens: [], adress: {} }, action) {
  switch (action.type) {
    case SET_DATA_END_ORDER: {
      return {
        ...state,
        ...action.payload
      }
    }


    case SET_ITENS: {
      return {
        ...state,
        itens: action.payload
      }
    }


    case SET_ADRESS_TO_DELIVERY: {
      return {
        ...state,
        adress: action.payload
      }
    }


    default: return state;
  }
}